
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { AlertController, LoadingController, ModalController, Platform } from 'ionic-angular';
import { AchivementData } from '../../shared/nestjs/gd-only/dto/gamification.dto';
import { GamificationNestApi } from '../../shared/nestjs/gd-only/services/gamification.api';
import { AlertServiceProvider } from '../alert-service/alert-service';
import { SFGOAuthService } from '../sfgoauth.service/sfgoauth.service';
import { ToastServiceProvider } from '../toast-service/toast.service';
import { Subject } from 'rxjs';

@Injectable()
export class GamificationProvider {

  /**
   * Parameters getAchievement :
   * badgeModule :
   * attendanceIn => attendance (for achievement attendance)
   * TaskCaptain => task (who is assign task)
   * TaskFinisher => task (who is doing task)
   */
  public badgeChanged = new Subject();
  constructor(
    public alertCtrl: AlertController,
    public storage: Storage,
    public loadingCtrl: LoadingController,
    public toastService: ToastServiceProvider,
    public alertService: AlertServiceProvider,
    public platform: Platform,
    public translate: TranslateService,
    public modalCtrl: ModalController,
    public gamificationNestApi: GamificationNestApi,
    public sfgoAuthService: SFGOAuthService
  ) {

  }

  async showModalAchivment(data: AchivementData, achiveName: string) {
    return new Promise((resolve) => {
      let assignImage = this.assignImage(achiveName);
      let modal = this.modalCtrl.create("BadgeModalPage", { data: data, badge: assignImage });

      modal.onDidDismiss((data) => {
        resolve(data);
      })

      modal.present();
    })
  }

  assignImage(name, badge: 'circle' | 'box' = 'box') {
    let badgePath = ''
    if (name == 'Early Bird') {
      badgePath = badge == 'circle' ? "assets/images/gamification/early-bird-icon.svg" : "assets/images/gamification/early-bird.svg";
    } else if (name == 'The Night Owl') {
      badgePath = badge == 'circle' ? "assets/images/gamification/night-owl-icon.svg" : "assets/images/gamification/night-owl.svg";
    } else if (name == 'Traveller') {
      badgePath = badge == 'circle' ? "assets/images/gamification/traveler-icon.svg" : "assets/images/gamification/traveler.svg";
    } else if (name == 'Finisher') {
      badgePath = badge == 'circle' ? "assets/images/gamification/finisher-icon.svg" : "assets/images/gamification/finisher.svg";
    } else if (name == 'The Captain') {
      badgePath = badge == 'circle' ? "assets/images/gamification/captain-icon.svg" : "assets/images/gamification/captain.svg";
    } else if (name == 'Early Riser') {
      badgePath = badge == 'circle' ? "assets/images/gamification/early-riser-icon.svg" : "assets/images/gamification/early-riser.svg";
    } else if (name == 'Workaholic') {
      badgePath = badge == 'circle' ? "assets/images/gamification/workaholic-icon.svg" : "assets/images/gamification/workaholic.svg";
    } else if (name == 'The Commander') {
      badgePath = badge == 'circle' ? "assets/images/gamification/commander-icon.svg" : "assets/images/gamification/commander.svg";
    } else if (name == 'Godspeed') {
      badgePath = badge == 'circle' ? "assets/images/gamification/godspeed-icon.svg" : "assets/images/gamification/godspeed.svg";
    } else if (name == 'Eager Beaver') {
      badgePath = badge == 'circle' ? "assets/images/gamification/eager-beaver-icon.svg" : "assets/images/gamification/eager-beaver.svg";
    }

    return badgePath;
  }

  assignDesc(name) {
    if (name == 'Early Bird') {
      return "Earn this badge by coming to office earlier for X times in a row.";
    } else if (name == 'The Night Owl') {
      return "Win this badge by working overtime for X times.";
    } else if (name == 'Traveller') {
      return "Earn this badge by taking business trip for X times.";
    } else if (name == 'Finisher') {
      return "Earn this badge by completing task for X times.";
    } else if (name == 'The Captain') {
      return "Get this badge by assigning task for X times."
    } else if (name == 'Workaholic') {
      return "Earn this badge by reaching the longest working hour on the leaderboard for X times.";
    } else if (name == 'The Commander') {
      return "Get this badge by assigning task quarterly for X times.";
    } else if (name == 'Godspeed') {
      return "Win this badge by completing task before the deadline for X times.";
    } else if (name == 'Eager Beaver') {
      return "Earn this badge by completing task quarterly for X times.";
    } else if (name == 'Early Riser') {
      return "Earn this badge by reaching the highest attendance point on the leaderboard for X times.";
    }
  }

  checkAchievement(badge: string) {
    return new Promise(async (resolve) => {
      const isGopathNew = await this.sfgoAuthService.isGopathNew();
      const params = { badgeModule: badge }

      if (isGopathNew) {
        this.gamificationNestApi.cekAchievement(params)
          .subscribe(async (result) => {
            if (JSON.stringify(result.data) !== '{}') {
              await this.showModalAchivment(result.data, result.data.tgospgmfmbadge.name);
              resolve()
            }
            else {
              resolve()
            }
          }, error => {
            console.log(error);
            resolve();
          })
      }
    })
  }


}





// WEBPACK FOOTER //
// ./src/providers/gamification/gamification.ts